// extracted by mini-css-extract-plugin
export default {"Wrapper":"OrganizationDocumentsActions_Wrapper__vh-ju"};